import { render, staticRenderFns } from "./GlobalSearchDestinationsList.vue?vue&type=template&id=778316f4&"
import script from "./GlobalSearchDestinationsList.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearchDestinationsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports